import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Homepage" }

import httpClient from '@/Api/HttpClient';
import BabillardComponent from '@/components/home/BabillardComponent.vue';
import ShowSliderComponent from "@/components/home/ShowSliderComponent.vue";
import { AxiosResponse } from 'axios';
import { onMounted, ref } from 'vue';

interface Offer {
  id: number;
  title: string;
  count: number;
  image: string;
  showId: number;
  createdAt: string;
  updatedAt: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const loading = ref(true);
const offers = ref<Offer[]>([]);

onMounted(() => {
  httpClient
    .get('/portal/most-clicked-offers')
    .then((response: AxiosResponse) => {
      if (response.status === 200) {
        offers.value = response.data.result;
      }
    })
    .catch((e: any) => {})
    .finally(() => {
      loading.value = false;
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ShowSliderComponent, {
      offers: offers.value,
      loading: loading.value
    }, null, 8, ["offers", "loading"]),
    _createVNode(BabillardComponent)
  ]))
}
}

})